export const CREATE_VENUE = 'line-up/venue/CREATE_VENUE';
